module.exports = "/images/vendor/desiigner-svg/svg/logos/lonelyplanet-stack.svg?f0aa53caf9c35b95ddda210d5e4a92e3";